import pick from 'lodash/pick';

export default function uploadResultToAttachmentInput(attachment) {
  // We want to avoid sending extra fields to the graphql mutation with AttachmentInput.
  // Here we are hand picking the fields that we need from the uploadResult that we got from onComplete callback of FileUploader
  if (!attachment) return null;

  return pick(attachment, ['fileId', 'fileName', 'path']);
}
